import { render, staticRenderFns } from "./PrometEdit.vue?vue&type=template&id=3cf759bf&scoped=true&"
import script from "./PrometEdit.vue?vue&type=script&lang=js&"
export * from "./PrometEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf759bf",
  null
  
)

export default component.exports